import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';

export default class QuizNameQuestion extends Component {
  static propTypes = {
    formErrors: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    handleNextClick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired
  };

  handleContinue = () => {
    const { handleNextClick } = this.props;
    handleNextClick();
  };

  render() {
    const { formErrors, formState, onChange, isValid } = this.props;

    const firstName =
      formState.buyer_profile_attributes.user_attributes.first_name || '';
    const lastName =
      formState.buyer_profile_attributes.user_attributes.last_name || '';

    return (
      <div className="AdoptionApplicationQuizNameQuestion relative">
        <div>
          <FullPageQuizQuestion
            title="What's your name?"
            isValid={isValid}
            handleNextClick={this.handleContinue}
          >
            <div className="row mb6">
              <div className="col">
                <ErrorWrapper
                  errors={get(
                    formErrors,
                    'buyer_profile_attributes.user_attributes.first_name'
                  )}
                >
                  <FullPageQuizTextInput
                    type="text"
                    name="buyer_profile_attributes.user_attributes.first_name"
                    value={firstName || ''}
                    onChange={onChange}
                    placeholder="First"
                    autoComplete="given-name"
                  />
                </ErrorWrapper>
              </div>
              <div className="col">
                <ErrorWrapper
                  errors={get(
                    formErrors,
                    'buyer_profile_attributes.user_attributes.last_name'
                  )}
                >
                  <FullPageQuizTextInput
                    type="text"
                    name="buyer_profile_attributes.user_attributes.last_name"
                    value={lastName}
                    onChange={onChange}
                    placeholder="Last"
                    autoComplete="family-name"
                  />
                </ErrorWrapper>
              </div>
            </div>
          </FullPageQuizQuestion>
        </div>
      </div>
    );
  }
}
